// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","995":"component---src-templates-page-jsx"}[chunkId] + "-" + {"125":"851b1e250ce9def8be80","995":"c4ee3755c77d1425bedb"}[chunkId] + ".js";
};